
export const config =  {

    URL_PICKLOG: import.meta.env.VITE_API_PICKLOG_BASE_URL || 'https://api.picklog.online/api',
    URL_AKERON: import.meta.env.VITE_AKERON_API_URL || 'https://picklog.akeron.net/api'

}